import styled from 'styled-components';
import { propStyles } from '../../../../../utils/propStyles';

const StyledComponent = styled<any, any>('button')`
    ${propStyles};
    border: none;
`;

StyledComponent.defaultProps = {
    background: 'transparent',
    color: 'inherit',
    cursor: 'pointer',
    padding: '10px',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Feedback/Components/Toast/StyledComponents/ToastCloseButton.tsx